import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "button"]

  connect() {
    this.handleClickOutside = this.handleClickOutside.bind(this)
    document.addEventListener("click", this.handleClickOutside)
  }

  disconnect() {
    document.removeEventListener("click", this.handleClickOutside)
  }

  toggle() {
    this.listTarget.classList.toggle("hidden")
    this.buttonTarget.classList.toggle("font-select-field__button--active")
  }

  handleClickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.listTarget.classList.add("hidden")
    }
  }

  select(event) {
    const value = event.currentTarget.dataset.value
    const label = event.currentTarget.dataset.fontName
    const input = this.element.querySelector("select")

    if (!input) return

    input.value = value
    this.buttonTarget.innerHTML = `<span style="font-family: ${label};">${label}</span>`
    this.listTarget.classList.add("hidden")

    input.dispatchEvent(new Event("input", { bubbles: true }))
    input.dispatchEvent(new Event("change", { bubbles: true }))
  }
}
